var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.92 51.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.89,20.89c-.49.28-.99.51-1.48.7-.5.19-1.06.36-1.66.5l-.22.05v23.43c0,.5-.16.9-.47,1.22-.32.32-.72.47-1.22.47H5.47c-.5,0-.9-.15-1.22-.47-.32-.32-.47-.72-.47-1.22V12.41l25.38,16.6,14.35-9.38-.35-.24c-.42-.29-.82-.6-1.2-.93-.39-.34-.77-.69-1.14-1.05l-.16-.16-11.5,7.51L5.43,9.33h32.12l-.03-.31c-.05-.56-.06-1.1-.04-1.6.02-.5.08-1.02.16-1.54l.06-.33H5.47c-1.55,0-2.86.53-3.9,1.57s-1.57,2.35-1.57,3.9v34.55c0,1.55.53,2.86,1.57,3.9,1.04,1.04,2.35,1.57,3.9,1.57h47.38c1.55,0,2.86-.53,3.9-1.57,1.04-1.04,1.57-2.35,1.57-3.9v-24.92l-.42.24Z",
    fill: "#164679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.29,2.63c-1.56-1.56-3.45-2.34-5.68-2.34s-4.11.78-5.68,2.34-2.34,3.45-2.34,5.68.78,4.11,2.34,5.68,3.45,2.34,5.68,2.34,4.11-.78,5.68-2.34,2.34-3.45,2.34-5.68-.78-4.11-2.34-5.68Z",
    fill: "#f42f54",
    stroke: "#f42f54",
    strokeMiterlimit: 10,
    strokeWidth: 0.57
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageNew);
export default __webpack_public_path__ + "static/media/message-new.31f6f7b06e7af32293d99940648af232.svg";
export { ForwardRef as ReactComponent };